import { Modal } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Button } from '../../../components/Button';
import { menuMoney, type DigitalMenuBasketLine } from '../digital-menu.utils';
import { BasketQr } from './BasketQr';
import classes from '../digital-menu.module.scss';

type Props = { tenantId: string; opened: boolean; lines: DigitalMenuBasketLine[]; total: number; onClose: () => void; onQuantity: (key: string, delta: number) => void };

export function BasketSheet({ tenantId, opened, lines, total, onClose, onQuantity }: Props) {
  return <Modal opened={opened} onClose={onClose} title="הסל שלי" size="100%" xOffset={0} yOffset={0} transitionProps={{ transition: 'slide-up' }} dir="rtl" closeButtonProps={{ 'aria-label': 'סגירת הסל' }} classNames={{ inner: classes.productModalInner, content: `${classes.modal} ${classes.productModal}`, header: classes.basketHeader, body: classes.modalBody, title: classes.basketTitle }}>
    <div className={classes.basket}>
      {lines.length === 0 && <p className={classes.status}>הסל ריק</p>}
      <div className={classes.basketLines}>
      {lines.map((line) => <article className={classes.basketLine} key={line.key}>
        <div className={classes.basketLineHead}>
          <div className={classes.basketLineDetails}><h3>{line.name}</h3><strong>{menuMoney(line.unitPrice * line.quantity)}</strong></div>
          <div className={classes.quantity}>
            <Button variant="icon" ariaLabel={`הגדלת כמות ${line.name}`} disabled={line.quantity >= 99} onClick={() => onQuantity(line.key, 1)}><FontAwesomeIcon icon={faPlus as IconProp} /></Button>
            <output aria-label={`כמות ${line.name}`}>{line.quantity}</output>
            <Button variant="icon" ariaLabel={`הקטנת כמות ${line.name}`} onClick={() => onQuantity(line.key, -1)}><FontAwesomeIcon icon={faMinus as IconProp} /></Button>
          </div>
        </div>
        {line.choices.length > 0 && <p className={classes.muted}>{line.choices.join(' · ')}</p>}
      </article>)}
      {lines.length > 0 && <BasketQr tenantId={tenantId} lines={lines} />}
      </div>
      {lines.length > 0 && <footer className={classes.basketTotal}><span>סך הכול</span><strong>{menuMoney(total)}</strong></footer>}
    </div>
  </Modal>;
}